import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface LoginResponse {
  access_token: string;
  user: {
    id: number;
    login: string;
    imie: string;
    nazwisko: string;
    mail: string;
    language: string;
    dostep: number;
    aktywnosc: number;
  };
}

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private http: HttpClient) {}

  login(login: string, password: string): Observable<LoginResponse> {
    return this.http.post<LoginResponse>('/auth/login', { login, password });
  }
}
